export enum AdobeTagsEnum {
  INHERITANCE_DIGITAL_PATH = 'coo_wave_smc_inheritance_overview',
  MISSING_DEATH_CERTIFICATE = 'coo_wave_smc_inheritance_cdc',
  GIFTING_DIGITAL_PATH = 'coo_wave_smc_gifting_overview',
  INTERNAL_TRANSFER_DIGITAL_PATH = 'coo_wave_smc_internal_transfer_overview',
}

const generateSMCCallDict = (callToActionTag: string) => ({
  inheritanceDigitalPath: {
    location: 'coo-inheritance-overview',
    processType: 'coo-inheritance-flow',
    ctaName: `${callToActionTag}`,
  },
  inheritanceMissingDeathCert: {
    location: 'coo-inheritance-overview',
    processType: 'coo-inheritance-flow',
    ctaName: `${callToActionTag}`,
  },
  giftingDigitalPath: {
    location: 'coo-gifting-overview',
    processType: 'coo-gifting-flow',
    ctaName: `${callToActionTag}`,
  },
  internalTransferDigitalPath: {
    location: 'coo-internal_transfer-overview',
    processType: 'coo-internal_transfer-flow',
    ctaName: `${callToActionTag}`,
  },
});

export const getSMCCallData = (smcTemplateKey, spoids, adobeKey) => {
  const callToActionTag = AdobeTagsEnum[adobeKey];

  const dict = generateSMCCallDict(callToActionTag);

  const data = dict[smcTemplateKey];
  return {
    ...data,
    ctaType: 'button',
    sPOID: spoids.clientSpoid,
    crewSPOID: spoids.crewSpoid,
  };
};
